import React from 'react'
import '../css/home.css'
import { Link } from 'react-router-dom';

// add a image uploader 

const Demo = () => {
  return (
    <div className='demo-app'>
        <div className='heading white'>Connect yourself to the Tron blockchain.</div>
        <Link to='/pay'>
            <button className='button white'>Tron Link &rarr;</button>
        </Link>
    </div>
  )
}

export default Demo
